import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { LangModule } from "../modules/lang/lang.module";
import { ConstructionComponent } from './construction/construction';
import { ErrorComponent } from './error/error';

const COMPONENTS = [
	ConstructionComponent,
	ErrorComponent
];

@NgModule({
    declarations: [...COMPONENTS],
    entryComponents: [...COMPONENTS],
    exports: [...COMPONENTS],
    imports: [
        CommonModule,
        IonicModule,
        LangModule,
    ]
})
export class ComponentsModule { }
